<svg class="tree-svg"
    viewBox="0 0 327 315"
    xmlns="http://www.w3.org/2000/svg">

    @if (!hideBranch()) {
        <!-- Smaller branch shadow -->
        <mask id="mask0_7217_63052" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="50" y="35" width="161" height="436">
            <path class="filter-blur" d="M53.5719 90.384C52.9285 90.384 52.1422 90.137 51.5313 89.725C50.8165 89.219 50.3832 88.52 50.7667 87.733C51.7415 87.155 60.2482 82.773 64.1474 80.707C56.8212 73.8022 58.3636 64.6433 68.274 59.4523C72.8382 57.0438 78.4054 55.8721 84.0115 55.8721C91.0257 55.8721 98.1071 57.7025 103.349 61.2289C103.737 61.453 104.075 61.6658 104.391 61.9593C113.708 68.9091 112.664 79.137 102.024 84.648C97.4919 87.027 91.9355 88.192 86.3294 88.192C79.5968 88.192 72.7927 86.519 67.6133 83.277C63.7249 85.387 55.3244 89.844 54.1936 90.285C54.016 90.35 53.8059 90.384 53.5719 90.384Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_7217_63052)">
            <path d="M129.6904 78.077L91.1275 24.5015L34.4009 68.1786L72.9638 121.754L129.6904 78.077Z" fill="var(--shade-bg)" />
        </g>
        
    } @else {
        <!-- Longer branch shadow -->
        <mask id="mask0_7217_63052" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="50" y="55" width="161" height="436">
            <path class="filter-blur" d="M53.5719 110.384C52.9285 110.384 52.1422 110.137 51.5313 109.725C50.8165 109.219 50.3832 108.52 50.7667 107.733C51.7415 107.155 60.2482 102.773 64.1474 100.707C56.8212 93.8022 58.3636 84.6433 68.274 79.4523C72.8382 77.0438 78.4054 75.8721 84.0115 75.8721C91.0257 75.8721 98.1071 77.7025 103.349 81.2289C103.737 81.453 104.075 81.6658 104.391 81.9593C113.708 88.9091 112.664 99.137 102.024 104.648C97.4919 107.027 91.9355 108.192 86.3294 108.192C79.5968 108.192 72.7927 106.519 67.6133 103.277C63.7249 105.387 55.3244 109.844 54.1936 110.285C54.016 110.35 53.8059 110.384 53.5719 110.384Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_7217_63052)">
            <path d="M129.6904 98.077L91.1275 44.5015L34.4009 88.1786L72.9638 141.754L129.6904 98.077Z" fill="var(--shade-bg)" />
        </g>
    }

    

 
    
    
    <mask
        id="mask3_4808_46588"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="43"
        y="57"
        width="9"
        height="53">
        <path
            d="M43.6188 57.0654H51.3825V109.832H43.6188V57.0654Z"
            fill="white" />
    </mask>
    <g mask="url(#mask3_4808_46588)">
        <mask
            id="mask4_4808_46588"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="44"
            y="57"
            width="7"
            height="53">
            <path
                d="M50.8019 108.215C50.3969 109.861 46.0926 110.571 44.221 107.847C44.0845 105.795 44.221 57.3457 44.221 57.3457L50.8019 57.7714C50.8019 57.7714 51.0056 106.064 50.8019 108.215Z"
                fill="white" />
        </mask>
        <g mask="url(#mask4_4808_46588)">
            <mask
                id="mask5_4808_46588"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="44"
                y="57"
                width="7"
                height="53">
                <path
                    d="M50.8019 108.215C50.3969 109.861 46.0926 110.571 44.221 107.847C44.0845 105.795 44.221 57.3457 44.221 57.3457L50.8019 57.7714C50.8019 57.7714 51.0056 106.064 50.8019 108.215Z"
                    fill="white" />
            </mask>
            <g mask="url(#mask5_4808_46588)">
                    @if (!hideBranch()) {
                        <path
                        d="M44.0845 57.3457V110.571H51.0056V57.3457H44.0845Z"
                        fill="url(#paint0_linear_4808_46588)" />
                    } @else {
                        <path
                        d="M44.0845 57.3457 V90.571 H51.0056 V57.3457 H44.0845 Z"
                        fill="url(#paint0_linear_4808_46588)" />
                    }
            </g>
        </g>
    </g>
    <mask
        id="mask6_4808_46588"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="10"
        y="63"
        width="40"
        height="29">
        <path
            d="M10.9003 63.9482H49.7188V91.4786H10.9003V63.9482Z"
            fill="white" />
    </mask>

    <g mask="url(#mask9_4808_46588)">
        <mask
            id="mask10_4808_46588"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="11"
            y="0"
            width="70"
            height="72">
            <path
                d="M80.1801 38.1965C80.1801 57.621 64.4707 72.4526 45.1351 71.2674C25.8211 70.0441 11.8751 54.7711 11.8751 35.4318C11.8751 15.9535 28.4488 -0.524793 47.7475 0.691758C67.0745 1.82765 80.1801 18.8146 80.1801 38.1965Z"
                fill="white" />
        </mask>
        <g mask="url(#mask10_4808_46588)">
            <mask
                id="mask11_4808_46588"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="11"
                y="0"
                width="70"
                height="72">
                <path
                    d="M80.1801 38.1965C80.1801 57.621 64.4707 72.4526 45.1351 71.2674C25.8211 70.0441 11.8751 54.7711 11.8751 35.4318C11.8751 15.9535 28.4488 -0.524793 47.7475 0.691758C67.0745 1.82765 80.1801 18.8146 80.1801 38.1965Z"
                    fill="white" />
            </mask>
            <g mask="url(#mask11_4808_46588)">
                <path
                    d="M11.8751 -4.67627V72.4526L80.1801 76.6064V-0.524761L11.8751 -4.67627Z"
                    fill="url(#paint2_linear_4808_46588)" />
            </g>
        </g>
    </g>


    @if (!hideBranch()) {
        <ng-container [ngTemplateOutlet]="branch"></ng-container>
        
    }

    <ng-container [ngTemplateOutlet]="gradient"></ng-container>
</svg>

<ng-template #gradient>
    <svg:defs>
        <filter
            id="filter0_f_4808_46588"
            x="46.6238"
            y="59.8721"
            width="80.1223"
            height="54.5117"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB">
            <feFlood
                flood-opacity="0"
                result="BackgroundImageFix" />
            <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape" />
            <feGaussianBlur
                stdDeviation="5"
                result="effect1_foregroundBlur_4808_46588" />
        </filter>
        <linearGradient
            id="paint0_linear_4808_46588"
            x1="44.0852"
            y1="83.5063"
            x2="51.0065"
            y2="83.5063"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#687CFE" />
            <stop
                offset="0.015625"
                stop-color="#687CFE" />
            <stop
                offset="0.0234375"
                stop-color="#687BFD" />
            <stop
                offset="0.03125"
                stop-color="#687AFD" />
            <stop
                offset="0.0390625"
                stop-color="#6779FC" />
            <stop
                offset="0.046875"
                stop-color="#6778FB" />
            <stop
                offset="0.0546875"
                stop-color="#6777FB" />
            <stop
                offset="0.0625"
                stop-color="#6776FA" />
            <stop
                offset="0.0703125"
                stop-color="#6675F9" />
            <stop
                offset="0.078125"
                stop-color="#6674F9" />
            <stop
                offset="0.0859375"
                stop-color="#6673F8" />
            <stop
                offset="0.09375"
                stop-color="#6672F7" />
            <stop
                offset="0.101562"
                stop-color="#6671F7" />
            <stop
                offset="0.109375"
                stop-color="#6570F6" />
            <stop
                offset="0.117188"
                stop-color="#656FF5" />
            <stop
                offset="0.125"
                stop-color="#656EF5" />
            <stop
                offset="0.132812"
                stop-color="#656DF4" />
            <stop
                offset="0.140625"
                stop-color="#646CF3" />
            <stop
                offset="0.148438"
                stop-color="#646BF3" />
            <stop
                offset="0.15625"
                stop-color="#646AF2" />
            <stop
                offset="0.164062"
                stop-color="#6469F1" />
            <stop
                offset="0.171875"
                stop-color="#6368F1" />
            <stop
                offset="0.179688"
                stop-color="#6367F0" />
            <stop
                offset="0.1875"
                stop-color="#6366EF" />
            <stop
                offset="0.195312"
                stop-color="#6365EF" />
            <stop
                offset="0.203125"
                stop-color="#6364EE" />
            <stop
                offset="0.210938"
                stop-color="#6263ED" />
            <stop
                offset="0.21875"
                stop-color="#6262ED" />
            <stop
                offset="0.226562"
                stop-color="#6261EC" />
            <stop
                offset="0.234375"
                stop-color="#6260EB" />
            <stop
                offset="0.242188"
                stop-color="#615FEB" />
            <stop
                offset="0.25"
                stop-color="#615EEA" />
            <stop
                offset="0.257812"
                stop-color="#615DE9" />
            <stop
                offset="0.265625"
                stop-color="#615CE9" />
            <stop
                offset="0.273438"
                stop-color="#615BE8" />
            <stop
                offset="0.28125"
                stop-color="#605AE7" />
            <stop
                offset="0.289062"
                stop-color="#6059E7" />
            <stop
                offset="0.296875"
                stop-color="#6058E6" />
            <stop
                offset="0.304688"
                stop-color="#6057E5" />
            <stop
                offset="0.3125"
                stop-color="#5F56E5" />
            <stop
                offset="0.320312"
                stop-color="#5F55E4" />
            <stop
                offset="0.328125"
                stop-color="#5F54E3" />
            <stop
                offset="0.335938"
                stop-color="#5F53E3" />
            <stop
                offset="0.34375"
                stop-color="#5F52E2" />
            <stop
                offset="0.351562"
                stop-color="#5E51E1" />
            <stop
                offset="0.359375"
                stop-color="#5E50E1" />
            <stop
                offset="0.367188"
                stop-color="#5E4FE0" />
            <stop
                offset="0.375"
                stop-color="#5E4EDF" />
            <stop
                offset="0.382812"
                stop-color="#5D4DDF" />
            <stop
                offset="0.390625"
                stop-color="#5D4CDE" />
            <stop
                offset="0.398438"
                stop-color="#5D4BDD" />
            <stop
                offset="0.40625"
                stop-color="#5D4ADD" />
            <stop
                offset="0.414062"
                stop-color="#5D49DC" />
            <stop
                offset="0.421875"
                stop-color="#5C48DB" />
            <stop
                offset="0.429688"
                stop-color="#5C47DB" />
            <stop
                offset="0.4375"
                stop-color="#5C46DA" />
            <stop
                offset="0.445312"
                stop-color="#5C45D9" />
            <stop
                offset="0.453125"
                stop-color="#5B44D9" />
            <stop
                offset="0.460938"
                stop-color="#5B43D8" />
            <stop
                offset="0.46875"
                stop-color="#5B42D7" />
            <stop
                offset="0.476562"
                stop-color="#5B41D7" />
            <stop
                offset="0.484375"
                stop-color="#5A40D6" />
            <stop
                offset="0.492188"
                stop-color="#5A3FD5" />
            <stop
                offset="0.5"
                stop-color="#5A3ED5" />
            <stop
                offset="0.507812"
                stop-color="#5A3DD4" />
            <stop
                offset="0.515625"
                stop-color="#5A3CD3" />
            <stop
                offset="0.523438"
                stop-color="#593BD3" />
            <stop
                offset="0.53125"
                stop-color="#593AD2" />
            <stop
                offset="0.539062"
                stop-color="#5939D1" />
            <stop
                offset="0.546875"
                stop-color="#5938D1" />
            <stop
                offset="0.554688"
                stop-color="#5837D0" />
            <stop
                offset="0.5625"
                stop-color="#5836CF" />
            <stop
                offset="0.570312"
                stop-color="#5835CF" />
            <stop
                offset="0.578125"
                stop-color="#5834CE" />
            <stop
                offset="0.585938"
                stop-color="#5833CD" />
            <stop
                offset="0.59375"
                stop-color="#5732CD" />
            <stop
                offset="0.601562"
                stop-color="#5731CC" />
            <stop
                offset="0.609375"
                stop-color="#5730CB" />
            <stop
                offset="0.617188"
                stop-color="#572FCB" />
            <stop
                offset="0.625"
                stop-color="#562ECA" />
            <stop
                offset="0.632812"
                stop-color="#562DC9" />
            <stop
                offset="0.640625"
                stop-color="#562CC9" />
            <stop
                offset="0.648438"
                stop-color="#562BC8" />
            <stop
                offset="0.65625"
                stop-color="#562AC7" />
            <stop
                offset="0.664062"
                stop-color="#5529C7" />
            <stop
                offset="0.671875"
                stop-color="#5528C6" />
            <stop
                offset="0.679688"
                stop-color="#5527C5" />
            <stop
                offset="0.6875"
                stop-color="#5526C5" />
            <stop
                offset="0.695312"
                stop-color="#5425C4" />
            <stop
                offset="0.703125"
                stop-color="#5424C3" />
            <stop
                offset="0.710938"
                stop-color="#5423C3" />
            <stop
                offset="0.71875"
                stop-color="#5422C2" />
            <stop
                offset="0.726562"
                stop-color="#5421C1" />
            <stop
                offset="0.734375"
                stop-color="#5320C1" />
            <stop
                offset="0.742188"
                stop-color="#531FC0" />
            <stop
                offset="0.75"
                stop-color="#531EBF" />
            <stop
                offset="0.757812"
                stop-color="#531DBF" />
            <stop
                offset="0.765625"
                stop-color="#521CBE" />
            <stop
                offset="0.773438"
                stop-color="#521BBD" />
            <stop
                offset="0.78125"
                stop-color="#521ABD" />
            <stop
                offset="0.789062"
                stop-color="#5219BC" />
            <stop
                offset="0.796875"
                stop-color="#5118BB" />
            <stop
                offset="0.804688"
                stop-color="#5117BB" />
            <stop
                offset="0.8125"
                stop-color="#5116BA" />
            <stop
                offset="0.820312"
                stop-color="#5115B9" />
            <stop
                offset="0.828125"
                stop-color="#5114B9" />
            <stop
                offset="0.835938"
                stop-color="#5013B8" />
            <stop
                offset="0.84375"
                stop-color="#5012B7" />
            <stop
                offset="0.851562"
                stop-color="#5011B7" />
            <stop
                offset="0.859375"
                stop-color="#5010B6" />
            <stop
                offset="0.867188"
                stop-color="#4F0FB5" />
            <stop
                offset="0.875"
                stop-color="#4F0EB5" />
            <stop
                offset="0.882812"
                stop-color="#4F0DB4" />
            <stop
                offset="0.890625"
                stop-color="#4F0CB3" />
            <stop
                offset="0.898438"
                stop-color="#4F0BB3" />
            <stop
                offset="0.90625"
                stop-color="#4E0AB2" />
            <stop
                offset="0.914062"
                stop-color="#4E09B1" />
            <stop
                offset="0.921875"
                stop-color="#4E08B1" />
            <stop
                offset="0.929688"
                stop-color="#4E07B0" />
            <stop
                offset="0.9375"
                stop-color="#4D06AF" />
            <stop
                offset="0.945312"
                stop-color="#4D05AF" />
            <stop
                offset="0.953125"
                stop-color="#4D04AE" />
            <stop
                offset="0.960938"
                stop-color="#4D03AD" />
            <stop
                offset="0.96875"
                stop-color="#4D02AD" />
            <stop
                offset="0.976562"
                stop-color="#4C01AC" />
            <stop
                offset="0.984375"
                stop-color="#4C00AB" />
            <stop
                offset="1"
                stop-color="#4C00AB" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_4808_46588"
            x1="11.0528"
            y1="77.507"
            x2="50.2523"
            y2="77.507"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#687CFE" />
            <stop
                offset="0.0078125"
                stop-color="#687CFE" />
            <stop
                offset="0.015625"
                stop-color="#687BFD" />
            <stop
                offset="0.0234375"
                stop-color="#677AFC" />
            <stop
                offset="0.03125"
                stop-color="#6779FC" />
            <stop
                offset="0.0390625"
                stop-color="#6778FB" />
            <stop
                offset="0.046875"
                stop-color="#6777FA" />
            <stop
                offset="0.0546875"
                stop-color="#6776FA" />
            <stop
                offset="0.0625"
                stop-color="#6675F9" />
            <stop
                offset="0.0703125"
                stop-color="#6674F8" />
            <stop
                offset="0.078125"
                stop-color="#6673F8" />
            <stop
                offset="0.0859375"
                stop-color="#6672F7" />
            <stop
                offset="0.09375"
                stop-color="#6571F6" />
            <stop
                offset="0.101562"
                stop-color="#6570F6" />
            <stop
                offset="0.109375"
                stop-color="#656FF5" />
            <stop
                offset="0.117188"
                stop-color="#656EF4" />
            <stop
                offset="0.125"
                stop-color="#656DF4" />
            <stop
                offset="0.132812"
                stop-color="#646CF3" />
            <stop
                offset="0.140625"
                stop-color="#646BF2" />
            <stop
                offset="0.148438"
                stop-color="#646AF2" />
            <stop
                offset="0.15625"
                stop-color="#6469F1" />
            <stop
                offset="0.164062"
                stop-color="#6368F0" />
            <stop
                offset="0.171875"
                stop-color="#6367F0" />
            <stop
                offset="0.179688"
                stop-color="#6366EF" />
            <stop
                offset="0.1875"
                stop-color="#6365EF" />
            <stop
                offset="0.195312"
                stop-color="#6364EE" />
            <stop
                offset="0.203125"
                stop-color="#6263ED" />
            <stop
                offset="0.210938"
                stop-color="#6262ED" />
            <stop
                offset="0.21875"
                stop-color="#6261EC" />
            <stop
                offset="0.226562"
                stop-color="#6260EB" />
            <stop
                offset="0.234375"
                stop-color="#615FEB" />
            <stop
                offset="0.242188"
                stop-color="#615EEA" />
            <stop
                offset="0.25"
                stop-color="#615DE9" />
            <stop
                offset="0.257812"
                stop-color="#615CE9" />
            <stop
                offset="0.265625"
                stop-color="#615BE8" />
            <stop
                offset="0.273438"
                stop-color="#605AE7" />
            <stop
                offset="0.28125"
                stop-color="#6059E7" />
            <stop
                offset="0.289062"
                stop-color="#6058E6" />
            <stop
                offset="0.296875"
                stop-color="#6057E5" />
            <stop
                offset="0.304688"
                stop-color="#5F56E5" />
            <stop
                offset="0.3125"
                stop-color="#5F55E4" />
            <stop
                offset="0.320312"
                stop-color="#5F54E3" />
            <stop
                offset="0.328125"
                stop-color="#5F53E3" />
            <stop
                offset="0.335938"
                stop-color="#5F52E2" />
            <stop
                offset="0.34375"
                stop-color="#5E51E1" />
            <stop
                offset="0.351562"
                stop-color="#5E50E1" />
            <stop
                offset="0.359375"
                stop-color="#5E4FE0" />
            <stop
                offset="0.367188"
                stop-color="#5E4EDF" />
            <stop
                offset="0.375"
                stop-color="#5D4DDF" />
            <stop
                offset="0.382812"
                stop-color="#5D4CDE" />
            <stop
                offset="0.390625"
                stop-color="#5D4BDD" />
            <stop
                offset="0.398438"
                stop-color="#5D4ADD" />
            <stop
                offset="0.40625"
                stop-color="#5D49DC" />
            <stop
                offset="0.414062"
                stop-color="#5C48DB" />
            <stop
                offset="0.421875"
                stop-color="#5C47DB" />
            <stop
                offset="0.429688"
                stop-color="#5C46DA" />
            <stop
                offset="0.4375"
                stop-color="#5C45D9" />
            <stop
                offset="0.445312"
                stop-color="#5B44D9" />
            <stop
                offset="0.453125"
                stop-color="#5B43D8" />
            <stop
                offset="0.460938"
                stop-color="#5B42D7" />
            <stop
                offset="0.46875"
                stop-color="#5B41D7" />
            <stop
                offset="0.476562"
                stop-color="#5B40D6" />
            <stop
                offset="0.484375"
                stop-color="#5A3FD5" />
            <stop
                offset="0.492188"
                stop-color="#5A3ED5" />
            <stop
                offset="0.5"
                stop-color="#5A3DD4" />
            <stop
                offset="0.507812"
                stop-color="#5A3CD3" />
            <stop
                offset="0.515625"
                stop-color="#593CD3" />
            <stop
                offset="0.523438"
                stop-color="#593BD2" />
            <stop
                offset="0.53125"
                stop-color="#593AD2" />
            <stop
                offset="0.539062"
                stop-color="#5939D1" />
            <stop
                offset="0.546875"
                stop-color="#5938D0" />
            <stop
                offset="0.554688"
                stop-color="#5837D0" />
            <stop
                offset="0.5625"
                stop-color="#5836CF" />
            <stop
                offset="0.570312"
                stop-color="#5835CE" />
            <stop
                offset="0.578125"
                stop-color="#5834CE" />
            <stop
                offset="0.585938"
                stop-color="#5733CD" />
            <stop
                offset="0.59375"
                stop-color="#5732CC" />
            <stop
                offset="0.601562"
                stop-color="#5731CC" />
            <stop
                offset="0.609375"
                stop-color="#5730CB" />
            <stop
                offset="0.617188"
                stop-color="#572FCA" />
            <stop
                offset="0.625"
                stop-color="#562ECA" />
            <stop
                offset="0.632812"
                stop-color="#562DC9" />
            <stop
                offset="0.640625"
                stop-color="#562CC8" />
            <stop
                offset="0.648438"
                stop-color="#562BC8" />
            <stop
                offset="0.65625"
                stop-color="#552AC7" />
            <stop
                offset="0.664062"
                stop-color="#5529C6" />
            <stop
                offset="0.671875"
                stop-color="#5528C6" />
            <stop
                offset="0.679688"
                stop-color="#5527C5" />
            <stop
                offset="0.6875"
                stop-color="#5526C4" />
            <stop
                offset="0.695312"
                stop-color="#5425C4" />
            <stop
                offset="0.703125"
                stop-color="#5424C3" />
            <stop
                offset="0.710938"
                stop-color="#5423C2" />
            <stop
                offset="0.71875"
                stop-color="#5422C2" />
            <stop
                offset="0.726562"
                stop-color="#5321C1" />
            <stop
                offset="0.734375"
                stop-color="#5320C0" />
            <stop
                offset="0.742188"
                stop-color="#531FC0" />
            <stop
                offset="0.75"
                stop-color="#531EBF" />
            <stop
                offset="0.757812"
                stop-color="#531DBE" />
            <stop
                offset="0.765625"
                stop-color="#521CBE" />
            <stop
                offset="0.773438"
                stop-color="#521BBD" />
            <stop
                offset="0.78125"
                stop-color="#521ABC" />
            <stop
                offset="0.789062"
                stop-color="#5219BC" />
            <stop
                offset="0.796875"
                stop-color="#5118BB" />
            <stop
                offset="0.804688"
                stop-color="#5117BA" />
            <stop
                offset="0.8125"
                stop-color="#5116BA" />
            <stop
                offset="0.820312"
                stop-color="#5115B9" />
            <stop
                offset="0.828125"
                stop-color="#5114B8" />
            <stop
                offset="0.835938"
                stop-color="#5013B8" />
            <stop
                offset="0.84375"
                stop-color="#5012B7" />
            <stop
                offset="0.851562"
                stop-color="#5011B6" />
            <stop
                offset="0.859375"
                stop-color="#5010B6" />
            <stop
                offset="0.867188"
                stop-color="#4F0FB5" />
            <stop
                offset="0.875"
                stop-color="#4F0EB5" />
            <stop
                offset="0.882812"
                stop-color="#4F0DB4" />
            <stop
                offset="0.890625"
                stop-color="#4F0CB3" />
            <stop
                offset="0.898438"
                stop-color="#4F0BB3" />
            <stop
                offset="0.90625"
                stop-color="#4E0AB2" />
            <stop
                offset="0.914062"
                stop-color="#4E09B1" />
            <stop
                offset="0.921875"
                stop-color="#4E08B1" />
            <stop
                offset="0.929688"
                stop-color="#4E07B0" />
            <stop
                offset="0.9375"
                stop-color="#4D06AF" />
            <stop
                offset="0.945312"
                stop-color="#4D05AF" />
            <stop
                offset="0.953125"
                stop-color="#4D04AE" />
            <stop
                offset="0.960938"
                stop-color="#4D03AD" />
            <stop
                offset="0.96875"
                stop-color="#4D02AD" />
            <stop
                offset="0.976562"
                stop-color="#4C01AC" />
            <stop
                offset="0.984375"
                stop-color="#4C00AB" />
            <stop
                offset="1"
                stop-color="#4C00AB" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_4808_46588"
            x1="11.8746"
            y1="33.8768"
            x2="80.1808"
            y2="33.8768"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#5D99E4" />
            <stop
                offset="0.015625"
                stop-color="#5D99E4" />
            <stop
                offset="0.03125"
                stop-color="#5D98E4" />
            <stop
                offset="0.046875"
                stop-color="#5D97E3" />
            <stop
                offset="0.0625"
                stop-color="#5D97E3" />
            <stop
                offset="0.078125"
                stop-color="#5D96E3" />
            <stop
                offset="0.09375"
                stop-color="#5D96E3" />
            <stop
                offset="0.109375"
                stop-color="#5C95E2" />
            <stop
                offset="0.125"
                stop-color="#5C94E2" />
            <stop
                offset="0.140625"
                stop-color="#5C94E2" />
            <stop
                offset="0.15625"
                stop-color="#5C93E2" />
            <stop
                offset="0.171875"
                stop-color="#5C93E1" />
            <stop
                offset="0.1875"
                stop-color="#5C92E1" />
            <stop
                offset="0.203125"
                stop-color="#5C91E1" />
            <stop
                offset="0.210938"
                stop-color="#5B91E0" />
            <stop
                offset="0.21875"
                stop-color="#5B90E0" />
            <stop
                offset="0.226562"
                stop-color="#5B90E0" />
            <stop
                offset="0.234375"
                stop-color="#5B8FDF" />
            <stop
                offset="0.242188"
                stop-color="#5A8EDF" />
            <stop
                offset="0.25"
                stop-color="#5A8EDF" />
            <stop
                offset="0.257812"
                stop-color="#5A8DDE" />
            <stop
                offset="0.265625"
                stop-color="#5A8CDE" />
            <stop
                offset="0.273438"
                stop-color="#598BDD" />
            <stop
                offset="0.28125"
                stop-color="#598ADD" />
            <stop
                offset="0.289062"
                stop-color="#598ADC" />
            <stop
                offset="0.296875"
                stop-color="#5889DC" />
            <stop
                offset="0.304688"
                stop-color="#5888DB" />
            <stop
                offset="0.3125"
                stop-color="#5787DB" />
            <stop
                offset="0.320312"
                stop-color="#5786DA" />
            <stop
                offset="0.328125"
                stop-color="#5785DA" />
            <stop
                offset="0.332031"
                stop-color="#5684D9" />
            <stop
                offset="0.335938"
                stop-color="#5683D9" />
            <stop
                offset="0.339844"
                stop-color="#5683D9" />
            <stop
                offset="0.34375"
                stop-color="#5682D8" />
            <stop
                offset="0.347656"
                stop-color="#5582D8" />
            <stop
                offset="0.351562"
                stop-color="#5581D8" />
            <stop
                offset="0.355469"
                stop-color="#5581D8" />
            <stop
                offset="0.359375"
                stop-color="#5580D7" />
            <stop
                offset="0.363281"
                stop-color="#5580D7" />
            <stop
                offset="0.367188"
                stop-color="#547FD7" />
            <stop
                offset="0.371094"
                stop-color="#547FD6" />
            <stop
                offset="0.375"
                stop-color="#547ED6" />
            <stop
                offset="0.378906"
                stop-color="#547ED6" />
            <stop
                offset="0.382812"
                stop-color="#537DD6" />
            <stop
                offset="0.386719"
                stop-color="#537DD5" />
            <stop
                offset="0.390625"
                stop-color="#537CD5" />
            <stop
                offset="0.394531"
                stop-color="#537BD5" />
            <stop
                offset="0.398438"
                stop-color="#527BD4" />
            <stop
                offset="0.402344"
                stop-color="#527AD4" />
            <stop
                offset="0.40625"
                stop-color="#527AD4" />
            <stop
                offset="0.410156"
                stop-color="#5279D3" />
            <stop
                offset="0.414062"
                stop-color="#5278D3" />
            <stop
                offset="0.417969"
                stop-color="#5178D3" />
            <stop
                offset="0.421875"
                stop-color="#5177D2" />
            <stop
                offset="0.425781"
                stop-color="#5177D2" />
            <stop
                offset="0.429688"
                stop-color="#5176D2" />
            <stop
                offset="0.433594"
                stop-color="#5075D1" />
            <stop
                offset="0.4375"
                stop-color="#5075D1" />
            <stop
                offset="0.441406"
                stop-color="#5074D1" />
            <stop
                offset="0.445312"
                stop-color="#5074D0" />
            <stop
                offset="0.449219"
                stop-color="#4F73D0" />
            <stop
                offset="0.453125"
                stop-color="#4F72D0" />
            <stop
                offset="0.457031"
                stop-color="#4F72CF" />
            <stop
                offset="0.460938"
                stop-color="#4E71CF" />
            <stop
                offset="0.464844"
                stop-color="#4E70CF" />
            <stop
                offset="0.46875"
                stop-color="#4E70CE" />
            <stop
                offset="0.472656"
                stop-color="#4E6FCE" />
            <stop
                offset="0.476562"
                stop-color="#4D6FCE" />
            <stop
                offset="0.480469"
                stop-color="#4D6ECD" />
            <stop
                offset="0.484375"
                stop-color="#4D6DCD" />
            <stop
                offset="0.488281"
                stop-color="#4D6DCD" />
            <stop
                offset="0.492188"
                stop-color="#4C6CCC" />
            <stop
                offset="0.496094"
                stop-color="#4C6BCC" />
            <stop
                offset="0.5"
                stop-color="#4C6BCB" />
            <stop
                offset="0.503906"
                stop-color="#4C6ACB" />
            <stop
                offset="0.507812"
                stop-color="#4B69CB" />
            <stop
                offset="0.511719"
                stop-color="#4B69CA" />
            <stop
                offset="0.515625"
                stop-color="#4B68CA" />
            <stop
                offset="0.519531"
                stop-color="#4A67CA" />
            <stop
                offset="0.523438"
                stop-color="#4A67C9" />
            <stop
                offset="0.527344"
                stop-color="#4A66C9" />
            <stop
                offset="0.53125"
                stop-color="#4A65C8" />
            <stop
                offset="0.535156"
                stop-color="#4964C8" />
            <stop
                offset="0.539062"
                stop-color="#4964C8" />
            <stop
                offset="0.542969"
                stop-color="#4963C7" />
            <stop
                offset="0.546875"
                stop-color="#4862C7" />
            <stop
                offset="0.550781"
                stop-color="#4862C7" />
            <stop
                offset="0.554688"
                stop-color="#4861C6" />
            <stop
                offset="0.558594"
                stop-color="#4860C6" />
            <stop
                offset="0.5625"
                stop-color="#4760C5" />
            <stop
                offset="0.566406"
                stop-color="#475FC5" />
            <stop
                offset="0.570312"
                stop-color="#475EC5" />
            <stop
                offset="0.574219"
                stop-color="#465DC4" />
            <stop
                offset="0.578125"
                stop-color="#465DC4" />
            <stop
                offset="0.582031"
                stop-color="#465CC3" />
            <stop
                offset="0.585938"
                stop-color="#455BC3" />
            <stop
                offset="0.589844"
                stop-color="#455AC3" />
            <stop
                offset="0.59375"
                stop-color="#455AC2" />
            <stop
                offset="0.597656"
                stop-color="#4559C2" />
            <stop
                offset="0.601562"
                stop-color="#4458C1" />
            <stop
                offset="0.605469"
                stop-color="#4457C1" />
            <stop
                offset="0.609375"
                stop-color="#4457C1" />
            <stop
                offset="0.613281"
                stop-color="#4356C0" />
            <stop
                offset="0.617188"
                stop-color="#4355C0" />
            <stop
                offset="0.621094"
                stop-color="#4354BF" />
            <stop
                offset="0.625"
                stop-color="#4254BF" />
            <stop
                offset="0.628906"
                stop-color="#4253BE" />
            <stop
                offset="0.632812"
                stop-color="#4252BE" />
            <stop
                offset="0.636719"
                stop-color="#4151BE" />
            <stop
                offset="0.640625"
                stop-color="#4151BD" />
            <stop
                offset="0.644531"
                stop-color="#4150BD" />
            <stop
                offset="0.648438"
                stop-color="#404FBC" />
            <stop
                offset="0.652344"
                stop-color="#404EBC" />
            <stop
                offset="0.65625"
                stop-color="#404EBB" />
            <stop
                offset="0.660156"
                stop-color="#404DBB" />
            <stop
                offset="0.664062"
                stop-color="#3F4CBB" />
            <stop
                offset="0.667969"
                stop-color="#3F4BBA" />
            <stop
                offset="0.671875"
                stop-color="#3F4ABA" />
            <stop
                offset="0.675781"
                stop-color="#3E4AB9" />
            <stop
                offset="0.679688"
                stop-color="#3E49B9" />
            <stop
                offset="0.683594"
                stop-color="#3E48B8" />
            <stop
                offset="0.6875"
                stop-color="#3D47B8" />
            <stop
                offset="0.691406"
                stop-color="#3D46B8" />
            <stop
                offset="0.695312"
                stop-color="#3D46B7" />
            <stop
                offset="0.699219"
                stop-color="#3C45B7" />
            <stop
                offset="0.703125"
                stop-color="#3C44B6" />
            <stop
                offset="0.707031"
                stop-color="#3C43B6" />
            <stop
                offset="0.710938"
                stop-color="#3B42B5" />
            <stop
                offset="0.714844"
                stop-color="#3B41B5" />
            <stop
                offset="0.71875"
                stop-color="#3B41B4" />
            <stop
                offset="0.722656"
                stop-color="#3A40B4" />
            <stop
                offset="0.726562"
                stop-color="#3A3FB4" />
            <stop
                offset="0.730469"
                stop-color="#3A3EB3" />
            <stop
                offset="0.734375"
                stop-color="#393DB3" />
            <stop
                offset="0.738281"
                stop-color="#393DB2" />
            <stop
                offset="0.742188"
                stop-color="#393CB2" />
            <stop
                offset="0.746094"
                stop-color="#383BB1" />
            <stop
                offset="0.75"
                stop-color="#383AB1" />
            <stop
                offset="0.753906"
                stop-color="#3839B0" />
            <stop
                offset="0.757812"
                stop-color="#3738B0" />
            <stop
                offset="0.761719"
                stop-color="#3738AF" />
            <stop
                offset="0.765625"
                stop-color="#3637AF" />
            <stop
                offset="0.769531"
                stop-color="#3636AE" />
            <stop
                offset="0.773438"
                stop-color="#3635AE" />
            <stop
                offset="0.777344"
                stop-color="#3534AE" />
            <stop
                offset="0.78125"
                stop-color="#3533AD" />
            <stop
                offset="0.785156"
                stop-color="#3532AD" />
            <stop
                offset="0.789062"
                stop-color="#3432AC" />
            <stop
                offset="0.792969"
                stop-color="#3431AC" />
            <stop
                offset="0.796875"
                stop-color="#3430AB" />
            <stop
                offset="0.800781"
                stop-color="#332FAB" />
            <stop
                offset="0.804688"
                stop-color="#332EAA" />
            <stop
                offset="0.808594"
                stop-color="#332DAA" />
            <stop
                offset="0.8125"
                stop-color="#322CA9" />
            <stop
                offset="0.816406"
                stop-color="#322BA9" />
            <stop
                offset="0.820312"
                stop-color="#312BA8" />
            <stop
                offset="0.824219"
                stop-color="#312AA8" />
            <stop
                offset="0.828125"
                stop-color="#3129A7" />
            <stop
                offset="0.832031"
                stop-color="#3028A7" />
            <stop
                offset="0.835938"
                stop-color="#3027A6" />
            <stop
                offset="0.839844"
                stop-color="#3026A6" />
            <stop
                offset="0.84375"
                stop-color="#2F25A5" />
            <stop
                offset="0.847656"
                stop-color="#2F24A5" />
            <stop
                offset="0.851562"
                stop-color="#2F23A4" />
            <stop
                offset="0.855469"
                stop-color="#2E23A4" />
            <stop
                offset="0.859375"
                stop-color="#2E22A3" />
            <stop
                offset="0.863281"
                stop-color="#2D21A3" />
            <stop
                offset="0.867188"
                stop-color="#2D20A2" />
            <stop
                offset="0.871094"
                stop-color="#2D1FA2" />
            <stop
                offset="0.875"
                stop-color="#2C1EA1" />
            <stop
                offset="0.878906"
                stop-color="#2C1DA1" />
            <stop
                offset="0.882812"
                stop-color="#2C1CA0" />
            <stop
                offset="0.886719"
                stop-color="#2B1BA0" />
            <stop
                offset="0.890625"
                stop-color="#2B1A9F" />
            <stop
                offset="0.894531"
                stop-color="#2A199F" />
            <stop
                offset="0.898438"
                stop-color="#2A199E" />
            <stop
                offset="0.902344"
                stop-color="#2A189E" />
            <stop
                offset="0.90625"
                stop-color="#29179D" />
            <stop
                offset="0.910156"
                stop-color="#29169D" />
            <stop
                offset="0.914062"
                stop-color="#29159C" />
            <stop
                offset="0.917969"
                stop-color="#28149C" />
            <stop
                offset="0.921875"
                stop-color="#28139B" />
            <stop
                offset="0.925781"
                stop-color="#27129B" />
            <stop
                offset="0.929688"
                stop-color="#27119A" />
            <stop
                offset="0.933594"
                stop-color="#27109A" />
            <stop
                offset="0.9375"
                stop-color="#260F99" />
            <stop
                offset="0.941406"
                stop-color="#260E99" />
            <stop
                offset="0.945312"
                stop-color="#260D98" />
            <stop
                offset="0.949219"
                stop-color="#250C98" />
            <stop
                offset="0.953125"
                stop-color="#250B97" />
            <stop
                offset="0.957031"
                stop-color="#240B97" />
            <stop
                offset="0.960938"
                stop-color="#240A96" />
            <stop
                offset="0.964844"
                stop-color="#240996" />
            <stop
                offset="0.96875"
                stop-color="#230895" />
            <stop
                offset="0.972656"
                stop-color="#230795" />
            <stop
                offset="0.976562"
                stop-color="#220694" />
            <stop
                offset="0.980469"
                stop-color="#220594" />
            <stop
                offset="0.984375"
                stop-color="#220493" />
            <stop
                offset="0.988281"
                stop-color="#210393" />
            <stop
                offset="0.992188"
                stop-color="#210292" />
            <stop
                offset="0.996094"
                stop-color="#200192" />
            <stop
                offset="1"
                stop-color="#200091" />
        </linearGradient>
        <linearGradient
            id="paint3_linear_4808_46588"
            x1="-6.1397"
            y1="84.2077"
            x2="47.8586"
            y2="50.793"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#5D99E4" />
            <stop
                offset="0.125"
                stop-color="#5D99E4" />
            <stop
                offset="0.1875"
                stop-color="#5D99E4" />
            <stop
                offset="0.203125"
                stop-color="#5D98E4" />
            <stop
                offset="0.21875"
                stop-color="#5D97E3" />
            <stop
                offset="0.234375"
                stop-color="#5D96E3" />
            <stop
                offset="0.25"
                stop-color="#5C95E2" />
            <stop
                offset="0.265625"
                stop-color="#5C94E2" />
            <stop
                offset="0.28125"
                stop-color="#5C93E2" />
            <stop
                offset="0.296875"
                stop-color="#5C92E1" />
            <stop
                offset="0.304688"
                stop-color="#5C92E1" />
            <stop
                offset="0.3125"
                stop-color="#5C91E0" />
            <stop
                offset="0.320312"
                stop-color="#5B90E0" />
            <stop
                offset="0.328125"
                stop-color="#5B8FE0" />
            <stop
                offset="0.332031"
                stop-color="#5A8EDF" />
            <stop
                offset="0.335938"
                stop-color="#5A8EDF" />
            <stop
                offset="0.339844"
                stop-color="#5A8DDE" />
            <stop
                offset="0.34375"
                stop-color="#5A8DDE" />
            <stop
                offset="0.347656"
                stop-color="#5A8CDE" />
            <stop
                offset="0.351562"
                stop-color="#598BDD" />
            <stop
                offset="0.355469"
                stop-color="#598BDD" />
            <stop
                offset="0.359375"
                stop-color="#598ADD" />
            <stop
                offset="0.363281"
                stop-color="#5889DC" />
            <stop
                offset="0.367188"
                stop-color="#5889DC" />
            <stop
                offset="0.371094"
                stop-color="#5888DC" />
            <stop
                offset="0.375"
                stop-color="#5887DB" />
            <stop
                offset="0.378906"
                stop-color="#5787DB" />
            <stop
                offset="0.382812"
                stop-color="#5786DA" />
            <stop
                offset="0.386719"
                stop-color="#5785DA" />
            <stop
                offset="0.390625"
                stop-color="#5684D9" />
            <stop
                offset="0.394531"
                stop-color="#5683D9" />
            <stop
                offset="0.398438"
                stop-color="#5683D9" />
            <stop
                offset="0.402344"
                stop-color="#5582D8" />
            <stop
                offset="0.40625"
                stop-color="#5581D8" />
            <stop
                offset="0.410156"
                stop-color="#5580D7" />
            <stop
                offset="0.414062"
                stop-color="#547FD7" />
            <stop
                offset="0.417969"
                stop-color="#547FD6" />
            <stop
                offset="0.421875"
                stop-color="#547ED6" />
            <stop
                offset="0.425781"
                stop-color="#537DD5" />
            <stop
                offset="0.429688"
                stop-color="#537CD5" />
            <stop
                offset="0.433594"
                stop-color="#537BD4" />
            <stop
                offset="0.4375"
                stop-color="#527AD4" />
            <stop
                offset="0.441406"
                stop-color="#5279D3" />
            <stop
                offset="0.445312"
                stop-color="#5178D3" />
            <stop
                offset="0.449219"
                stop-color="#5177D2" />
            <stop
                offset="0.453125"
                stop-color="#5176D2" />
            <stop
                offset="0.457031"
                stop-color="#5075D1" />
            <stop
                offset="0.460938"
                stop-color="#5074D1" />
            <stop
                offset="0.464844"
                stop-color="#4F73D0" />
            <stop
                offset="0.46875"
                stop-color="#4F72D0" />
            <stop
                offset="0.472656"
                stop-color="#4F71CF" />
            <stop
                offset="0.476562"
                stop-color="#4E70CF" />
            <stop
                offset="0.480469"
                stop-color="#4E6FCE" />
            <stop
                offset="0.484375"
                stop-color="#4D6ECE" />
            <stop
                offset="0.488281"
                stop-color="#4D6DCD" />
            <stop
                offset="0.492188"
                stop-color="#4D6CCC" />
            <stop
                offset="0.496094"
                stop-color="#4C6BCC" />
            <stop
                offset="0.5"
                stop-color="#4C6ACB" />
            <stop
                offset="0.503906"
                stop-color="#4B69CB" />
            <stop
                offset="0.507812"
                stop-color="#4B68CA" />
            <stop
                offset="0.511719"
                stop-color="#4A67C9" />
            <stop
                offset="0.515625"
                stop-color="#4A66C9" />
            <stop
                offset="0.519531"
                stop-color="#4965C8" />
            <stop
                offset="0.523438"
                stop-color="#4964C8" />
            <stop
                offset="0.527344"
                stop-color="#4963C7" />
            <stop
                offset="0.53125"
                stop-color="#4862C6" />
            <stop
                offset="0.535156"
                stop-color="#4860C6" />
            <stop
                offset="0.539062"
                stop-color="#475FC5" />
            <stop
                offset="0.542969"
                stop-color="#475EC5" />
            <stop
                offset="0.546875"
                stop-color="#465DC4" />
            <stop
                offset="0.550781"
                stop-color="#465CC3" />
            <stop
                offset="0.554688"
                stop-color="#455BC3" />
            <stop
                offset="0.558594"
                stop-color="#455AC2" />
            <stop
                offset="0.5625"
                stop-color="#4458C1" />
            <stop
                offset="0.566406"
                stop-color="#4457C1" />
            <stop
                offset="0.570312"
                stop-color="#4356C0" />
            <stop
                offset="0.574219"
                stop-color="#4355BF" />
            <stop
                offset="0.578125"
                stop-color="#4254BF" />
            <stop
                offset="0.582031"
                stop-color="#4252BE" />
            <stop
                offset="0.585938"
                stop-color="#4151BE" />
            <stop
                offset="0.589844"
                stop-color="#4150BD" />
            <stop
                offset="0.59375"
                stop-color="#404FBC" />
            <stop
                offset="0.597656"
                stop-color="#404EBC" />
            <stop
                offset="0.601562"
                stop-color="#3F4CBB" />
            <stop
                offset="0.605469"
                stop-color="#3F4BBA" />
            <stop
                offset="0.609375"
                stop-color="#3E4AB9" />
            <stop
                offset="0.613281"
                stop-color="#3E49B9" />
            <stop
                offset="0.617188"
                stop-color="#3D47B8" />
            <stop
                offset="0.621094"
                stop-color="#3D46B7" />
            <stop
                offset="0.625"
                stop-color="#3C45B7" />
            <stop
                offset="0.628906"
                stop-color="#3C44B6" />
            <stop
                offset="0.632812"
                stop-color="#3B42B5" />
            <stop
                offset="0.636719"
                stop-color="#3B41B5" />
            <stop
                offset="0.640625"
                stop-color="#3A40B4" />
            <stop
                offset="0.644531"
                stop-color="#3A3EB3" />
            <stop
                offset="0.648438"
                stop-color="#393DB2" />
            <stop
                offset="0.652344"
                stop-color="#393CB2" />
            <stop
                offset="0.65625"
                stop-color="#383AB1" />
            <stop
                offset="0.660156"
                stop-color="#3739B0" />
            <stop
                offset="0.664062"
                stop-color="#3738B0" />
            <stop
                offset="0.667969"
                stop-color="#3636AF" />
            <stop
                offset="0.671875"
                stop-color="#3635AE" />
            <stop
                offset="0.675781"
                stop-color="#3534AD" />
            <stop
                offset="0.679688"
                stop-color="#3532AD" />
            <stop
                offset="0.683594"
                stop-color="#3431AC" />
            <stop
                offset="0.6875"
                stop-color="#3430AB" />
            <stop
                offset="0.691406"
                stop-color="#332EAA" />
            <stop
                offset="0.695312"
                stop-color="#322DAA" />
            <stop
                offset="0.699219"
                stop-color="#322CA9" />
            <stop
                offset="0.703125"
                stop-color="#312AA8" />
            <stop
                offset="0.707031"
                stop-color="#3129A7" />
            <stop
                offset="0.710938"
                stop-color="#3027A7" />
            <stop
                offset="0.714844"
                stop-color="#3026A6" />
            <stop
                offset="0.71875"
                stop-color="#2F25A5" />
            <stop
                offset="0.722656"
                stop-color="#2E23A4" />
            <stop
                offset="0.726562"
                stop-color="#2E22A3" />
            <stop
                offset="0.730469"
                stop-color="#2D20A3" />
            <stop
                offset="0.734375"
                stop-color="#2D1FA2" />
            <stop
                offset="0.738281"
                stop-color="#2C1DA1" />
            <stop
                offset="0.742188"
                stop-color="#2C1CA0" />
            <stop
                offset="0.746094"
                stop-color="#2B1BA0" />
            <stop
                offset="0.75"
                stop-color="#2A199F" />
            <stop
                offset="0.753906"
                stop-color="#2A189E" />
            <stop
                offset="0.757812"
                stop-color="#29169D" />
            <stop
                offset="0.761719"
                stop-color="#29159C" />
            <stop
                offset="0.765625"
                stop-color="#28139C" />
            <stop
                offset="0.769531"
                stop-color="#27129B" />
            <stop
                offset="0.773438"
                stop-color="#27109A" />
            <stop
                offset="0.777344"
                stop-color="#260F99" />
            <stop
                offset="0.78125"
                stop-color="#250D98" />
            <stop
                offset="0.785156"
                stop-color="#250C98" />
            <stop
                offset="0.789062"
                stop-color="#240A97" />
            <stop
                offset="0.792969"
                stop-color="#240996" />
            <stop
                offset="0.796875"
                stop-color="#230795" />
            <stop
                offset="0.800781"
                stop-color="#220694" />
            <stop
                offset="0.804688"
                stop-color="#220493" />
            <stop
                offset="0.808594"
                stop-color="#210393" />
            <stop
                offset="0.8125"
                stop-color="#210192" />
            <stop
                offset="0.816406"
                stop-color="#200191" />
            <stop
                offset="0.820312"
                stop-color="#200091" />
            <stop
                offset="0.828125"
                stop-color="#200091" />
            <stop
                offset="0.84375"
                stop-color="#200091" />
            <stop
                offset="0.875"
                stop-color="#200091" />
            <stop
                offset="1"
                stop-color="#200091" />
        </linearGradient>
    </svg:defs>
</ng-template>

<ng-template #branch>
    <svg:g mask="url(#mask6_4808_46588)">
        <mask
            id="mask7_4808_46588"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="11"
            y="64"
            width="39"
            height="27">
            <path
                d="M49.2791 86.9418C50.2517 87.9388 49.1275 91.0261 46.515 90.9567C45.0008 90.1031 11.0519 68.1178 11.0519 68.1178L13.8095 64.0581C13.8095 64.0581 47.8841 85.7947 49.2791 86.9418Z"
                fill="white" />
        </mask>
        <g mask="url(#mask7_4808_46588)">
            <mask
                id="mask8_4808_46588"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="11"
                y="64"
                width="39"
                height="27">
                <path
                    d="M49.2791 86.9418C50.2517 87.9388 49.1275 91.0261 46.515 90.9567C45.0008 90.1031 11.0519 68.1178 11.0519 68.1178L13.8095 64.0581C13.8095 64.0581 47.8841 85.7947 49.2791 86.9418Z"
                    fill="white" />
            </mask>
            <g mask="url(#mask8_4808_46588)">
                <path
                    d="M11.0519 64.0581V91.0261H50.2517V64.0581H11.0519Z"
                    fill="url(#paint1_linear_4808_46588)" />
            </g>
        </g>
    </svg:g>

    <svg:g mask="url(#mask12_4808_46588)">
        <mask
            id="mask13_4808_46588"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="48"
            width="42"
            height="41">
            <path
                d="M38.7926 58.3559C44.6631 67.7455 41.5502 79.8931 31.8932 85.4449C22.3771 91.0258 9.80869 87.8713 3.87326 78.4704C-1.92136 69.0472 1.10701 56.8526 10.764 51.1933C20.4318 45.6281 32.9915 48.8587 38.7926 58.3559Z"
                fill="white" />
        </mask>
        <g mask="url(#mask13_4808_46588)">
            <mask
                id="mask14_4808_46588"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="48"
                width="42"
                height="41">
                <path
                    d="M38.7926 58.3559C44.6631 67.7455 41.5502 79.8931 31.8932 85.4449C22.3771 91.0258 9.80869 87.8713 3.87326 78.4704C-1.92136 69.0472 1.10701 56.8526 10.764 51.1933C20.4318 45.6281 32.9915 48.8587 38.7926 58.3559Z"
                    fill="white" />
            </mask>
            <g mask="url(#mask14_4808_46588)">
                <path
                    d="M-22.6089 57.5941L10.3565 110.867L65.3502 79.0597L32.3848 25.7891L-22.6089 57.5941Z"
                    fill="url(#paint3_linear_4808_46588)" />
            </g>
        </g>
    </svg:g>
</ng-template>